import request from './base'

export const userList = (params) => {
    return request.post("/admin/v1/user/list", params)
}

export const userAdd = (params) => {
    return request.post("/admin/v1/user/add", params)
}

export const userModify = (params) => {
    return request.post("/admin/v1/user/modify", params)
}

export const userDelete = (params) => {
    return request.post("/admin/v1/user/delete", params)
}

export const userResetPassword = (params) => {
    return request.post("/admin/v1/user/reset/password", params)
}



// WEBPACK FOOTER //
// ./src/api/user.js